// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__228ZP","shimmer":"styles_shimmer__Zs87T"};